<div class="container mx-auto mt-4">
  <div class="card">
    <div class="card-body">
      <h3>Formulario de PQRS</h3>
      <div class="form-group">
        <label for="exampleInputEmail1">Numero de cedula</label>
        <input
          type="text"
          class="form-control"
          aria-describedby="emailHelp"
          [(ngModel)]="documentInformation.document_number"
          name="document_number"
          disabled
        />
      </div>
      <div class="form-group">
        <label for="exampleInputEmail1">Nombre</label>
        <input
          type="text"
          class="form-control"
          aria-describedby="emailHelp"
          [(ngModel)]="
            documentInformation.first_name + ' ' + documentInformation.last_name
          "
          name="full_name"
          disabled
        />
      </div>
      <form (ngSubmit)="handleFormSubmit()" [formGroup]="pqrForm">
        <div class="form-group">
          <label for="exampleInputEmail1">Email</label>
          <input
            type="text"
            class="form-control"
            [formControl]="pqrForm.controls.email"
            [ngClass]="{
              'is-valid':
                pqrForm.controls.email.touched && pqrForm.controls.email.valid,
              'is-invalid':
                pqrForm.controls.email.touched && !pqrForm.controls.email.valid
            }"
          />
          <div
            *ngIf="
              pqrForm.controls.email.touched &&
              !pqrForm.controls.email.valid &&
              pqrForm.controls.email.errors['email']
            "
            class="invalid-feedback"
          >
            Debes ingresar un correo valido
          </div>
          <div
            *ngIf="
              pqrForm.controls.email.touched &&
              !pqrForm.controls.email.valid &&
              pqrForm.controls.email.errors['required']
            "
            class="invalid-feedback"
          >
            Email es requerido
          </div>
        </div>
        <div class="form-group">
          <label>Tipo de PQR</label>
          <select
            class="custom-select"
            [formControl]="pqrForm.controls.kind"
            name="kind"
          >
            <option value="0">Petición</option>
            <option value="1">Queja</option>
            <option value="2">Recurso</option>
            <option value="3">Solicitud</option>
          </select>
        </div>
        <div class="form-group">
          <label>Tipo de Reclamo</label>
          <select
            class="custom-select"
            [formControl]="pqrForm.controls.reason"
            name="kind"
          >
            <option value="0">Por facturación</option>
            <option value="1">Por servicio</option>
          </select>
        </div>
        <div class="form-group">
          <label>Descripción de su PQR</label>
          <textarea
            class="form-control"
            rows="3"
            [formControl]="pqrForm.controls.description"
            [ngClass]="{
              'is-valid':
                pqrForm.controls.description.touched &&
                pqrForm.controls.description.valid,
              'is-invalid':
                pqrForm.controls.description.touched &&
                !pqrForm.controls.description.valid
            }"
          ></textarea>
          <div
            *ngIf="
              pqrForm.controls.description.touched &&
              !pqrForm.controls.description.valid &&
              pqrForm.controls.description.errors['maxlength']
            "
            class="invalid-feedback"
          >
            Maximo 2000 Caracteres
          </div>
          <div
            *ngIf="
              pqrForm.controls.description.touched &&
              !pqrForm.controls.description.valid &&
              pqrForm.controls.description.errors['required']
            "
            class="invalid-feedback"
          >
            La descripcion es requerida
          </div>
        </div>
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="!pqrForm.valid"
        >
          Crear PQR
        </button>
      </form>
    </div>
  </div>
</div>
